module.exports = __webpack_public_path__ + "img/DNA-logo.9f364cdc.png";